



















































































































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mainSiteLink } from '@/utils/plugins/links';
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';
import { mapGetters } from 'vuex';

interface Data {}

interface Methods {
  analyticsSend: () => void;
}

interface Computed {}

interface Props {}

export default Vue.extend({
  name: 'SiteFooter',
  mixins: [iconsMixin],
  computed: {
    ...mapGetters(['PPDAndTPDLinks', 'organization']),
  },
  methods: {
    getFullLink(route: string) {
      return mainSiteLink + route;
    },
    analyticsSend() {
      this.$analytics.logEvent('get_help', {
        screen: this.$route.meta.analyticsName,
      });
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
